import React, { useState } from "react";
import axios from "axios";

import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import DentalTreatement from "../Dental Treatment/dental_create";
import { useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Income = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  // const url = 'http://192.168.1.15:9000/api/'
  const api = apiInstance;

  const [treatmentLists, setTreatmentLists] = useState([]);
  const [treatmentUnit, setTreatmentUnit] = useState([]);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [searchList, setSearhList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showOri, setShowOri] = useState(true);

  const showDialog = () => setOpen(true);
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data);
      _export.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
      });
      _export.current.save();
    }
  };

  const handleDelete = (event) => {
    if (window.confirm("Delete ?")) {
      api
        .delete("dental-treatment-list/" + event)
        .then((response) => {
          Swal.fire({
            title: "Success",
            text: "Successfully Deleted!",
            icon: "success",
            confirmButtonText: "OK",
          });
          const result = treatmentLists.filter((item) => item._id !== event);
          setTreatmentLists(result);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    } else {
      navigate("/treatC");
    }
  };

  const submit = (id) => {
    confirmAlert({
      title: "Confirm to delete!",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelete(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const search = (val) => {
    if (val) {
      setSearhList(
        treatmentLists.filter(
          (el) =>
            el?.name.toLowerCase().includes(val.toLowerCase()) ||
            el?.code.toLowerCase().includes(val.toLowerCase()) ||
            el?.bodyParts.toLowerCase().includes(val.toLowerCase()),
        ),
      );
      setShowSearch(true);
      setShowOri(false);
    } else {
      setShowSearch(false);
      setShowOri(true);
    }
  };
  useEffect(() => {
    const getTreatmentLists = async () => {
      try {
        const res = await api.get("dental-treatment-lists");
        setTreatmentLists(
          res.data.list.sort(
            (a, b) => a.code?.split("-")[1] - b.code?.split("-")[1],
          ),
        );
        // console.log(res.data.list, 'treattt')
      } catch (err) {
        alert(err.message);
      }
    };
    const getTreatmentUnit = async () => {
      try {
        const res = await api.get("dental-treatment-units");
        setTreatmentUnit(
          res.data.list.sort(
            (a, b) => a.code?.split("-")[1] - b.code?.split("-")[1],
          ),
        );
        // setTreatmentLists(res.data.list)
        // console.log(res.data.list, 'treattt')
      } catch (err) {
        alert(err.message);
      }
    };
    getTreatmentUnit();
    getTreatmentLists();
  }, []);

  return (
    <>
        {/* <HeaderName /> */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item font-weight-bold text-xl">
                      Dental Treatment List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row flex justify-content-between mx-2">
                <div className="col-4 mt-2">
                  <button
                    className="btn btn-sm btn-success rounded-3"
                    onClick={excelExport}
                  >
                    Export
                  </button>
                </div>
                <div className="col-4 ml-5">
                  <div
                    className="flex input-group"
                    style={{ marginBottom: "20px" }}
                  >
                    <input
                      type="search"
                      className="form-control rounded"
                      style={{ borderRadius: "12px", width: "20px" }}
                      id="search_code"
                      placeholder="Search"
                      onChange={(e) => search(e.target.value)}
                    />

                    <button
                      type="button"
                      className="btn btn-sm btn-primary mt-1"
                      style={{ borderRadius: "7px", width: "80px" }}
                      onClick={showDialog}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header">
                      <div className="row justify-content-between">
                        <span className="float-right">
                          <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a>
                           <button
                              type="button"
                              className="btn btn-primary"
                              onClick={excelExport}>
                              Export Excel
                            </button>
                        </span>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div> */}

                    <div className="card-body">
                      {/* Export data in Excel */}
                      <ExcelExport data={treatmentLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />

                        <ExcelExportColumn
                          field="code"
                          title="Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="name"
                          title="Name"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="bodyParts"
                          title="Body Parts"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="description"
                          title="Description"
                          width={350}
                        />
                      </ExcelExport>
                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="table-responsive text-black"
                            id="slimtest2"
                          >
                            <table
                              className="table table-hover"
                              id="filter_date"
                            >
                              <thead className="">
                                <tr>
                                  <th>#</th>
                                  <th className="text-center">Code</th>
                                  <th className="text-center">Name</th>
                                  <th className="text-center">Body Parts</th>
                                  <th className="text-center">Description</th>
                                  <th className="text-center">
                                    Treatment Unit
                                  </th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>

                              {showSearch && (
                                <tbody className="text-center">
                                  {searchList.map((treatment, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{treatment.code}</td>
                                      <td>{treatment.name}</td>
                                      <td>{treatment.bodyParts}</td>
                                      <td>{treatment.description}</td>
                                      <td className="text-center">
                                        <Link
                                          to={"/dental-check/" + treatment._id}
                                        >
                                          <p className="btn btn-sm btn-dark rounded">
                                            Check Unit
                                          </p>
                                        </Link>
                                      </td>
                                      <td className="text-center">
                                        <Link
                                          to={"/dental-update/" + treatment._id}
                                          className="btn btn-sm btn-warning"
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={(e) => submit(treatment._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}

                              {showOri && (
                                <tbody className="text-center">
                                  {treatmentLists.map((treatment, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{treatment.code}</td>
                                      <td>{treatment.name}</td>
                                      <td>{treatment.bodyParts}</td>
                                      <td>{treatment.description}</td>
                                      <td className="text-center">
                                        <Link
                                          to={"/dental-check/" + treatment._id}
                                        >
                                          <p className="btn btn-sm btn-dark rounded">
                                            Check Unit
                                          </p>
                                        </Link>
                                      </td>
                                      <td className="text-center">
                                        <Link
                                          to={"/dental-update/" + treatment._id}
                                          className="btn btn-sm btn-warning"
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={() => submit(treatment._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <DentalTreatement
                open={open}
                close={() => setOpen(false)}
                setTreatmentLists={setTreatmentLists}
                treatmentLists={treatmentLists}
              />
            </div>
          </section>
        </div>

    </>
  );
};

export default Income;
